<template>
  <ContentWrapper v-if="getData" class="overflow-hidden">
    <h2 class="font-bold text-2xl xl:text-3xl mb-6 text-center">永續城市報導</h2>
    <div class="w-11/12 md:w-full m-auto">
      <!-- tab selector -->
      <div class="flex justify-center my-8">
        <label
          v-for="(selector, index) in getData"
          :key="index"
          :class="active === index ?
            'bg-green mx-1 md:mx-2 px-4 py-2 cursor-pointer text-white font-bold border border-green whitespace-nowrap' :
            'bg-white mx-1 md:mx-2 px-4 py-2 cursor-pointer border border-green text-green font-bold whitespace-nowrap'"
        >
          {{ setTitle(index) }}
          <input type="radio" v-model="active" :value="index" class="hidden">
        </label>
      </div>
      <!-- tab content -->
      <BtnetSlider :sliderData="getData[active]" />
    </div>
  </ContentWrapper>
</template>

<script>
import ContentWrapper from './models/ContentWrapper'
import BtnetSlider from './models/BtnetSlider'

export default {
  name: 'Report',
  components: {
    ContentWrapper,
    BtnetSlider
  },
  data() {
    return {
      active: 0
    }
  },
  computed: {
    getData() {
      if(!this.$store.state.indexData.report1) return false;
      return [
        this.$store.state.indexData.report1,
        this.$store.state.indexData.report2,
        this.$store.state.indexData.report3
      ];
    }
  },
  methods: {
    setTitle(index) {
      const title = {
        0: '地方創生',
        1: '投資台灣',
        2: '環境永續'
      }
      return title[index];
    }
  }
}
</script>
